"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
const useStore_entities_1 = require("../../contexts/useStore/useStore.entities");
class Role extends useStore_entities_1.Entity {
    static cache = true;
    static all = () => ({
        api: 'v0',
        method: 'GET',
        route: '/roles',
    });
}
exports.Role = Role;
//# sourceMappingURL=Role.js.map